import connect from "react-redux/es/connect/connect";

import DateFilter from "../../../../../components/rangePicker/rangePicker";
import {
	updateSurveyFilters,
	getSurveyDynFilterValues,
	setKeySurveyFilterSelected,
} from "redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	return {
		currentFilters: state.survey.surveyManager.currentFilters
			? state.survey.surveyManager.currentFilters[ownProps.filterTargetKey]
			: [],
		minDate:
			state.survey.surveyManager.keyFilterSelected === "SurveyPeriodicity" &&
			state.survey.surveyManager.filters &&
			state.survey.surveyManager.filters
				? state.survey.surveyManager.filters[0]
				: null,
		maxDate:
			state.survey.surveyManager.keyFilterSelected === "SurveyPeriodicity" &&
			state.survey.surveyManager.filters &&
			state.survey.surveyManager.filters
				? state.survey.surveyManager.filters[1]
				: null,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addFilter: values =>
			dispatch(updateSurveyFilters(ownProps.filterTargetKey, values)),
		getDynFilterValues: () =>
			dispatch(getSurveyDynFilterValues(ownProps.filterTargetKey)),
		setKeyFilterSelected: () =>
			dispatch(setKeySurveyFilterSelected(ownProps.filterTargetKey)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DateFilter);



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyRangePickerContainer.js